import { SortDescriptor } from "@progress/kendo-data-query";
import { SortField } from "../sort-field.model";

export class UsersFilter {
    email: string;
    firstName: string;
    lastName: string;
    applicationRole: string;
    lastUpdatedBy: string;
    lastUpdated: Date;
    dateOfDeactivation: Date;
    status: string;
    includeInactiveUsers: boolean = false;

    sortField: SortField;
} 